// extracted by mini-css-extract-plugin
export var body = "axP8HFZAd2ZKZVu2wLfV";
export var hero = "_l6_0mZY0YkcxZ5cxJs8";
export var large = "Q6iqBBJZqHHSk5AQ_a8o";
export var micro = "UmFLREToSGx2OgDJGfXL";
export var mini = "etfLopx8QuIA6NTn5bBJ";
export var small = "YZAW8r3idxZVZz2zDVOy";
export var title1 = "Yd7_XzxgZm5hKKjQ9vZN";
export var title2 = "JqDf824NuQXSB_YH_fzP";
export var title3 = "rhpCaaifBiebxt6nA5rp";